import * as yup from 'yup';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { getCheckboxDefinition } from '@gov-nx/utils/common';

export const useAuthorizationConsentDefinition = ({
	isDisabled = false,
	isConsentRequired = true,
}: {
	isDisabled?: boolean;
	isConsentRequired?: boolean;
}) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);
	const schema = useAuthorizationConsentYupSchema({ isConsentRequired });

	return {
		...getCheckboxDefinition({
			name: '__souhlas',
			isDisabled,
			defaultValue: false,
			label: t('form.field.souhlas'),
		}),
		schema,
	};
};

export const useAuthorizationConsentYupSchema = ({
	isConsentRequired = true,
}: {
	isConsentRequired?: boolean;
}) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);

	if (!isConsentRequired) {
		return yup.boolean().optional();
	}

	return yup
		.boolean()
		.required(t('form.validation.souhlas.povinny'))
		.oneOf([true], t('form.validation.souhlas.povinny'));
};
